/* unplugin-vue-components disabled */const { computed, ref } = require('vue');
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = n => ((0, vue_2.pushScopeId)("data-v-ec35c5b0"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { class: "center-panel-wrap" };
const _hoisted_2 = { class: "path-list-wrap" };
const _hoisted_3 = { class: "program-path-wrap" };
const ListItem_vue_1 = tslib_1.__importDefault(require("./ListItem.vue"));
const FeedBin_vue_1 = tslib_1.__importDefault(require("./FeedBin.vue"));
const model_1 = require("@/model");
const laborer_1 = require("@/store/modules/laborer");
exports.default = (0, vue_1.defineComponent)({
    __name: 'CoordList',
    setup(__props, { expose: __expose }) {
        const laborerStore = (0, laborer_1.useLaborer)();
        const tcpsGroups = computed(() => {
            var _a, _b;
            let tcps = ((_b = (_a = model_1.Project.current()) === null || _a === void 0 ? void 0 : _a.curProgram.robot) === null || _b === void 0 ? void 0 : _b.tcps.filter(tcp => tcp.reference.frame === 'rp')) || [];
            return tcps.map(tcp => {
                let paths = [{
                        id: `${tcp.id}_R1`,
                        name: tcp.refPoints.R1.name,
                        points: [tcp.refPoints.R1.data[0]],
                        type: 'coord',
                        refPointsData: tcp.refPoints.R1.data
                    }, {
                        id: `${tcp.id}_R2`,
                        name: tcp.refPoints.R2.name,
                        points: [tcp.refPoints.R2.data[0]],
                        type: 'coord',
                        refPointsData: tcp.refPoints.R2.data
                    }, {
                        id: `${tcp.id}_R3`,
                        name: tcp.refPoints.R3.name,
                        points: [tcp.refPoints.R3.data[0]],
                        type: 'coord',
                        refPointsData: tcp.refPoints.R3.data
                    }];
                return {
                    name: tcp.name,
                    paths: paths
                };
            });
        });
        const feedBinsRefs = tcpsGroups.value.map(() => ref(null));
        const setFeedBinsRef = (key) => {
            return (el) => {
                feedBinsRefs[key] = el;
            };
        };
        const playSavePointAnimate = () => {
            let pathId = laborerStore.pointState.path.id;
            let pathRef = feedBinsRefs[pathId];
            if (pathRef) {
                pathRef.playSaveAnimate(laborerStore.pointState.pointIndex);
            }
        };
        __expose({
            playSavePointAnimate
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(tcpsGroups), (group, index) => {
                        return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(ListItem_vue_1.default, {
                            key: `tcp${index}`
                        }, {
                            header: (0, vue_2.withCtx)(() => [
                                (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)(group.name), 1)
                            ]),
                            content: (0, vue_2.withCtx)(() => [
                                (0, vue_2.createElementVNode)("div", _hoisted_3, [
                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(group.paths, (path) => {
                                        return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(FeedBin_vue_1.default, {
                                            key: `coord${path.id}`,
                                            "feed-bin": path,
                                            mode: "point",
                                            ref_for: true,
                                            ref: setFeedBinsRef(path.id)
                                        }, null, 8, ["feed-bin"]));
                                    }), 128))
                                ])
                            ]),
                            _: 2
                        }, 1024));
                    }), 128))
                ])
            ]));
        };
    }
});
